import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import FormControl from "@mui/material/FormControl";
import {
  FormControlLabel,
  FormHelperText,
  Input,
  InputLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";

export default function UpdateCategory ({
  open,
  category,
  handleClose,
  handleSubmit,
  updateCategoryData,
  updateCategoryImage,
  handleChangeUpdateCategory,
  handleChangeUpdateCategoryImage,
}) {
  const theme = useTheme();

  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogTitle id='responsive-dialog-title'>{"Update Sub Category"}</DialogTitle>
        <form onSubmit={handleSubmit} style={{ width: "600px" }}>
          <DialogContent>
            <DialogContentText>
              <div style={{ display: "flex", gap: "20px" }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label>Name</label>
                  <input
                    value={updateCategoryData?.name}
                    onChange={handleChangeUpdateCategory}
                    name='name'
                    type='text'
                    required
                    placeholder='Enter Sub Category name'
                    style={{
                      padding: "10px",
                      border: "2px solid #c4c4c4",
                      borderRadius: "6px",
                      color: "gray",
                      width: "260px",
                    }}
                  />
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label>Category</label>
                  <select
                    onChange={handleChangeUpdateCategory}
                    name='categories'
                    style={{
                      padding: "10px",
                      border: "2px solid #c4c4c4",
                      borderRadius: "6px",
                      color: "gray",
                      width: "260px",
                    }}
                  >
                    <option value={""}>Select category</option>
                    {category.map((e, i) => (
                      <>
                        <option value={e.categoryId}>{e.name}</option>
                      </>
                    ))}
                  </select>
                </div>
              </div>
              <div style={{ display: "flex", gap: "20px" }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label>Image</label>
                  <div style={styles.previewContainer}>
                    <div style={styles.imageWrapper}>
                      <img
                        src={
                          updateCategoryImage?.image
                            ? URL.createObjectURL(updateCategoryImage?.image)
                            : updateCategoryData?.image
                        }
                        alt={`preview`}
                        style={styles.image}
                      />
                    </div>
                  </div>
                  <input
                    value={handleChangeUpdateCategoryImage?.image}
                    onChange={handleChangeUpdateCategoryImage}
                    name='image'
                    type='file'
                    // required
                    accept='image/*'
                    style={{
                      padding: "10px",
                      border: "2px solid #c4c4c4",
                      borderRadius: "6px",
                      color: "gray",
                      width: "260px",
                      marginTop: "5px",
                    }}
                  />
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label>Slug</label>
                  <input
                    value={updateCategoryData?.slug}
                    onChange={handleChangeUpdateCategory}
                    name='slug'
                    type='text'
                    required
                    placeholder='Enter slug'
                    style={{
                      padding: "10px",
                      border: "2px solid #c4c4c4",
                      borderRadius: "6px",
                      color: "gray",
                      width: "260px",
                    }}
                  />
                </div>
                {/* <div style={{ display: "flex", flexDirection: "column" }}>
                  <label>Order</label>
                  <input
                    value={updateCategoryData?.categoryOrder}
                    onChange={handleChangeUpdateCategory}
                    name='categoryOrder'
                    type='number'
                    min={0}
                    required
                    placeholder='Enter category order'
                    style={{
                      padding: "10px",
                      border: "2px solid #c4c4c4",
                      borderRadius: "6px",
                      color: "gray",
                      width: "260px",
                    }}
                  />
                </div> */}
                
              </div>
              <div style={{ display: "flex", gap: "20px" }}>
                
                <div style={{ paddingTop: "10px" }}>
                  <lable>Visible</lable>
                  <RadioGroup
                    style={{ width: "100%", color: "#7b809a" }}
                    row
                    aria-labelledby='demo-row-radio-buttons-group-label'
                    name='isActive'
                    required
                    onChange={handleChangeUpdateCategory}
                    value={updateCategoryData?.isActive}
                  >
                    <FormControlLabel
                      style={{ fontSize: "12px", color: "#7b809a", fontWeight: 400 }}
                      value={true}
                      control={<Radio size='small' />}
                      label='Yes'
                      defaultChecked={false}
                    />
                    <FormControlLabel
                      style={{ fontSize: "12px", color: "#7b809a" }}
                      value={false}
                      control={<Radio size='small' />}
                      defaultChecked={false}
                      label='Not Yet'
                    />
                  </RadioGroup>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {/* <Button autoFocus onClick={handleClose}>
            Disagree
            </Button> */}
            <Button type='submit' autoFocus>
              Submit
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
}

const styles = {
  container: {
    width: "80%",
    margin: "20px auto",
    textAlign: "center",
  },
  uploadBox: {
    width: "100%",
    height: "200px",
    border: "2px dashed #ccc",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    background: "#f9f9f9",
  },
  uploadContent: {
    textAlign: "center",
    color: "#333",
  },
  uploadIcon: {
    marginBottom: "10px",
  },
  previewContainer: {
    display: "flex",
    gap: "10px",
    // marginTop: "20px",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  imageWrapper: {
    position: "relative",
    width: "100%",
    height: "120px",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "10px",
    border: "1px solid #ddd",
  },
  removeBtn: {
    position: "absolute",
    top: "5px",
    right: "5px",
    background: "red",
    color: "white",
    border: "none",
    borderRadius: "50%",
    cursor: "pointer",
    width: "20px",
    height: "20px",
  },
};
